module.exports = __webpack_public_path__ + "static/media/08.022.ebc1a66d.jpg";